import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { IPageHeaderMeta } from '../../../shared/components/header/page-header/page-header-meta.interface';
import { IGroupData } from '../../../shared/models/list-models';
import {
  Direction,
  SortAndFilterService,
  TSortDirections,
} from '../../../shared/services/list-services/sort-and-filter.service';
import { IDropdownOption } from '../../../shared/typings/interfaces/design-library.interface';

@Component({
  selector: 'network-settings-content',
  template: require('./network-settings-content.component.html'),
  styles: [require('./network-settings-content.component.scss')],
})
export class NetworkSettingsContentComponent implements OnInit {
  @Input() groupData$: BehaviorSubject<IGroupData>;
  @Input() option$: BehaviorSubject<IDropdownOption[]>;
  @Input() optionSelected: string;
  @Output() madLibChange = new EventEmitter();
  @Output() clickedMoreButton = new EventEmitter();

  public batchActionsMode$: Observable<boolean>;
  public columnIndexMap: { [key: string]: number };
  public columns: any[];
  public listConfig: any;
  public sortKey$: BehaviorSubject<string>;
  public sortDirection$: BehaviorSubject<TSortDirections>;

  public pageHeaderMeta: IPageHeaderMeta = {
    textboxPlaceholder: 'Find a user...',
  };
  public userFilter: FormControl = new FormControl();

  ngOnInit(): void {
    this.sortKey$ = new BehaviorSubject('NAME');
    this.sortDirection$ = new BehaviorSubject<TSortDirections>(Direction.asc);
    this.columns = [
      {
        columnName: 'Name',
        columnOrder: 0,
        graphQlKey: 'NAME',
        cellTooltip: 'CLUSTER_USER_NAME',
      },
      {
        columnName: 'job title',
        columnOrder: 1,
        graphQlKey: 'JOB_TITLE',
      },
      {
        columnName: 'access level',
        columnDataFormat: '',
        columnOrder: 2,
        graphQlKey: 'ACCESS_LEVEL',
      },
      {
        columnName: 'school portfolio',
        columnOrder: 3,
        graphQlKey: 'SCHOOL_PORTFOLIO',
        cellTooltip: 'CLUSTER_USER_SCHOOL_PORTFOLIO',
      },
      {
        columnName: null,
        columnOrder: 4,
        graphQlKey: 'MORE',
      },
    ];

    this.batchActionsMode$ = of(false);

    this.columnIndexMap = this.columns.reduce((mapping, col: any, i: number) => {
      mapping[col.graphQlKey] = i;
      return mapping;
    }, {});

    this.listConfig = {
      listType: 'USER',
      noDataMessage: 'No users to display',
      sortableColumns: true,
    };
  }

  public onMadLibChange(e: string): void {
    this.madLibChange.emit(e);
  }

  public onMoreButtonClick({ action, user }): void {
    this.clickedMoreButton.emit({ action, user });
  }

  public updateSort(sortKey: string): void {
    SortAndFilterService.updateSortCol(sortKey, this.sortKey$, this.sortDirection$);
  }
}
